import React from 'react'
import { Link } from "react-router-dom";


const Faq = () => {
  return (
    <>
      <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
        <div className="auto-container">
          <h2>FAQ</h2>
          <ul className="bread-crumb clearfix">
            <li><Link to="/">Home</Link></li>
            <li style={{ color: "green" }}>FAQ</li>
          </ul>
        </div>
      </section>

      <section className="faq-page" style={{ overflow: "hidden", marginTop: "-60px" }}>
        <div className="auto-container">
          <div className="sec-title centered">
            <div className="sec-title_title">Frequently Asked Questions</div>
            <h2 className="sec-title_heading">If you want, you can find every single answer here.</h2>
            <p>All medical facilities are housed under one roof at Satna Swastik Hospital, a 25+ beds tertiary care facility with multiple super specialty services. The hospital is situated on one acre of lovely Satna land. The different services include:</p>
          </div>
          <div className="row clearfix">

            <div className="column col-lg-23 col-md-12 col-sm-12">

              <ul className="accordion-box" style={{ marginTop: "-110px" }}>

                <li className="accordion block">
                  <div className="acc-btn active "><div className="icon-outer"><span className="icon fa-solid fa-angle-right fa-fw" /></div>What are the services offered by Satna Swastik Hospital?</div>
                  <div className="acc-content current">
                    <div className="content">
                      <div className="text"><b style={{ color: "black" }}>Scope of Services</b></div>
                      <p style={{ color: "black" }}>Emergency 24 X 7</p>
                      <h1 style={{ marginTop: "-40px" }}> <b>Satna Swastik Hospital Super Services:</b></h1>

                      <ul className="doctor-detail_list-two">

                        <li>CTVS</li>
                        <li> Medical</li>
                        <li>Neuro Science</li>
                        <li>Neonatal</li>
                        <li> Surgical</li>
                        <li> Plastic Surgery</li>
                        <li> Cardio Thoracic Vascular Surgery</li>
                        <li> Cardiology</li>
                        <li> Endocrinology</li>
                        <li> Gastro Intestinal Surgery</li>
                        <li> Gastroenterology</li>
                        <li> Interventional Radiology</li>
                        <li> General Medicine</li>
                        <li> General Surgery</li>
                        <li>Obstetrics & Gynecology </li>
                        <li>Ophthalmology </li>
                        <li> Orthopedics</li>
                        <li> Pediatrics</li>
                        <li> Psychiatry</li>
                        <li>Skin & V.D. </li>
                        <li> 3.0 Tesla MRI</li>
                        <li> 1.5 Tesla MRI</li>
                        <li>64 Slice CT Scan </li>
                        <li>Color Doppler-4D </li>
                        <li> Mamography</li>
                        <li> X-Ray</li>
                        <li> Pharmacy 24 X 7</li>
                        <li>AIR Ambulance </li>
                        <li> Digital Payment</li>
                        <li>Executive Health-Checkup </li>

                      </ul>



                    </div>
                  </div>
                </li>



              </ul>
            </div>


          </div>
        </div>
      </section>


    </>
  )
}

export default Faq